export default "__VITE_ASSET__DCU9CZKy__"